<template>
    <page :busy="busy" :tabs="tabs" :compact-mobile-view="true">
        <router-view
            @busy="handleBusy"
        ></router-view>
    </page>
</template>

<script>
import Page from '../../generic/page/page.vue';
import { removeScrollMixin } from '../../../mixins/remove-scroll-mixin';

export default {
    name: 'Subscriber',
    components: {
        Page,
    },
    mixins: [removeScrollMixin],
    computed: {
        tabs() {
            return [
                {
                    title: `Registrations`,
                    route: `/app/subscriber/admin/registrations/`,
                    active: this.$route.path === `/app/subscriber/admin/registrations/`,
                },
                {
                    title: `Subscriptions`,
                    route: `/app/subscriber/admin/subscriptions/`,
                    active: this.$route.path === `/app/subscriber/admin/subscriptions/`,
                },
                {
                    title: `Users`,
                    route: `/app/subscriber/admin/users/`,
                    active: this.$route.path === `/app/subscriber/admin/users/`,
                },                
                {
                    title: `Airbnb Activations`,
                    route: `/app/subscriber/admin/airbnb/`,
                    active: this.$route.path === `/app/subscriber/admin/airbnb/`,
                },
                {
                    title: `Wordpress Installations`,
                    route: `/app/subscriber/admin/wordpress/`,
                    active: this.$route.path === `/app/subscriber/admin/wordpress/`,
                },
            ];
        }
    },
    data() {
        return {
            busy: false,
        }
    },
    methods: {
        handleBusy(busy) {
            this.busy = busy;
        },
    }
}
</script>
